var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperGlassMagnifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 121,
    viewBox: "0 0 138 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advisor home / no results"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M69.5 83.916C88.0015 83.916 103 68.9176 103 50.416C103 31.9145 88.0015 16.916 69.5 16.916C50.9985 16.916 36 31.9145 36 50.416C36 68.9176 50.9985 83.916 69.5 83.916Z",
    fill: "white",
    stroke: "#141929",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 61.784C93.4716 73.0485 82.464 81 69.6037 81C52.7017 81 39 67.2654 39 50.3229C39 34.9706 50.2503 22.2523 64.9376 20C63.5 38 84 58.5 98 61.784Z",
    fill: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1321 76.4099C65.8908 76.7345 67.6801 76.9032 69.5 76.916C84.1355 76.916 96 65.0516 96 50.416C96 35.7805 84.1355 23.916 69.5 23.916C65.7404 23.916 62.1636 24.6989 58.9238 26.1107C53.2938 28.5639 48.6816 32.9159 45.896 38.3579C44.0445 41.975 43 46.0735 43 50.416C43 54.356 43.8599 58.0952 45.4021 61.4561C46.5032 63.8556 47.9521 66.0623 49.6843 68.0116",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1321 76.4099C65.8908 76.7345 67.6801 76.9032 69.5 76.916C84.1355 76.916 96 65.0516 96 50.416C96 35.7805 84.1355 23.916 69.5 23.916C65.7404 23.916 62.1636 24.6989 58.9238 26.1107C53.2938 28.5639 48.6816 32.9159 45.896 38.3579C44.0445 41.975 43 46.0735 43 50.416C43 54.356 43.8599 58.0952 45.4021 61.4561C46.5032 63.8556 47.9521 66.0623 49.6843 68.0116",
    stroke: "#141929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M52.7974 70.9902C54.9455 72.7362 57.3723 74.1525 60.0008 75.1621",
    stroke: "#141929",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M97 76.916L103 82.916",
    stroke: "#141929",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.03 81.9469C100.138 83.8396 100.138 86.9083 102.03 88.801L113.116 99.8863C115.008 101.779 118.077 101.779 119.97 99.8863C121.863 97.9936 121.863 94.9249 119.97 93.0322L108.885 81.9469C106.992 80.0542 103.923 80.0542 102.03 81.9469Z",
    fill: "#EEF0F8",
    stroke: "#141929",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M107 83.916L118 94.916",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-3_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0005 38.9165C63.0005 50.5145 72.4025 59.9165 84.0005 59.9165C86.2789 59.9165 88.4725 59.5537 90.5267 58.8827C87.1737 67.2036 79.023 73.0772 69.5005 73.0772C56.9854 73.0772 46.8398 62.9317 46.8398 50.4165C46.8398 39.0761 55.1702 29.6813 66.0455 28.0176C64.1135 31.1958 63.0005 34.9262 63.0005 38.9165Z",
    fill: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M70 31.916C68.7266 31.916 67.4825 32.0413 66.2793 32.2802M62.6447 33.3921C55.8039 36.2668 51 43.0304 51 50.916",
    stroke: "#5B6792",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    d: "M123.176 50.6934H115M129.5 42.916H112.324H129.5ZM136.5 42.916H134.279H136.5Z",
    stroke: "#5B6792",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-8_2",
    d: "M33.1763 72.6934H25.0005M28.5005 63.916H11.3247H28.5005ZM5.50049 63.916H1.2793H5.50049Z",
    stroke: "#5B6792",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperGlassMagnifier);
export default __webpack_public_path__ + "static/media/paperGlassMagnifier.6cfb8aadd267a8ff79e4193d75700786.svg";
export { ForwardRef as ReactComponent };